import React, { useState } from 'react';
import { Modal } from './Modal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="w-full py-8 px-4 bg-charcoal text-cream" data-id="element-28">
        <div className="max-w-6xl mx-auto" data-id="element-29">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-30">
            <p className="text-sm text-cream/70" data-id="element-31">
              © {new Date().getFullYear()} The Nervous System Sleep Reset. All
              rights reserved.
            </p>
            <div className="flex items-center gap-6" data-id="element-32">
              <button onClick={() => setShowPrivacy(true)} className="text-sm text-cream/70 hover:text-cream transition-colors underline" data-id="element-33">
                Privacy Policy
              </button>
              <button onClick={() => setShowTerms(true)} className="text-sm text-cream/70 hover:text-cream transition-colors underline" data-id="element-34">
                Terms of Service
              </button>
            </div>
          </div>
        </div>
      </footer>

      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Privacy Policy" data-id="element-35">
        <div className="prose prose-sm md:prose-base max-w-none text-charcoal/80" data-id="element-36">
          <p className="mb-4" data-id="element-37">
            <strong data-id="element-38">Effective Date:</strong> {new Date().toLocaleDateString()}
          </p>

          <h3 className="text-xl font-serif font-bold text-charcoal mt-6 mb-3" data-id="element-39">
            1. Information We Collect
          </h3>
          <p className="mb-4" data-id="element-40">
            When you purchase The Nervous System Sleep Reset guide, we collect:
          </p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-41">
            <li data-id="element-42">Name and email address for product delivery</li>
            <li data-id="element-43">
              Payment information (processed securely through our payment
              provider)
            </li>
            <li data-id="element-44">Usage data to improve our products and services</li>
          </ul>

          <h3 className="text-xl font-serif font-bold text-charcoal mt-6 mb-3" data-id="element-45">
            2. How We Use Your Information
          </h3>
          <p className="mb-4" data-id="element-46">We use your information to:</p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-47">
            <li data-id="element-48">Deliver your purchased digital product</li>
            <li data-id="element-49">Send important updates about your purchase</li>
            <li data-id="element-50">Provide customer support</li>
            <li data-id="element-51">Improve our products and services</li>
          </ul>

          <h3 className="text-xl font-serif font-bold text-charcoal mt-6 mb-3" data-id="element-52">
            3. Data Security
          </h3>
          <p className="mb-4" data-id="element-53">
            We implement industry-standard security measures to protect your
            personal information. Payment processing is handled by secure
            third-party providers and we never store your complete payment
            information.
          </p>

          <h3 className="text-xl font-serif font-bold text-charcoal mt-6 mb-3" data-id="element-54">
            4. Sharing Your Information
          </h3>
          <p className="mb-4" data-id="element-55">
            We do not sell, trade, or rent your personal information to third
            parties. We may share information with trusted service providers who
            assist in operating our business, but only to the extent necessary
            to provide our services.
          </p>

          <h3 className="text-xl font-serif font-bold text-charcoal mt-6 mb-3" data-id="element-56">
            5. Your Rights
          </h3>
          <p className="mb-4" data-id="element-57">You have the right to:</p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-58">
            <li data-id="element-59">Access your personal data</li>
            <li data-id="element-60">Request correction of inaccurate data</li>
            <li data-id="element-61">Request deletion of your data</li>
            <li data-id="element-62">Opt-out of marketing communications</li>
          </ul>

          <h3 className="text-xl font-serif font-bold text-charcoal mt-6 mb-3" data-id="element-63">
            6. Cookies
          </h3>
          <p className="mb-4" data-id="element-64">
            We use cookies to enhance your browsing experience and analyze site
            traffic. You can control cookie preferences through your browser
            settings.
          </p>

          <h3 className="text-xl font-serif font-bold text-charcoal mt-6 mb-3" data-id="element-65">
            7. Changes to This Policy
          </h3>
          <p className="mb-4" data-id="element-66">
            We may update this privacy policy from time to time. We will notify
            you of any changes by posting the new policy on this page with an
            updated effective date.
          </p>

          <h3 className="text-xl font-serif font-bold text-charcoal mt-6 mb-3" data-id="element-67">
            8. Contact Us
          </h3>
          <p className="mb-4" data-id="element-68">
            If you have questions about this privacy policy, please contact us
            through our support channels.
          </p>
        </div>
      </Modal>

      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Terms of Service" data-id="element-69">
        <div className="prose prose-sm md:prose-base max-w-none text-charcoal/80" data-id="element-70">
          <p className="mb-4" data-id="element-71">
            <strong data-id="element-72">Effective Date:</strong> {new Date().toLocaleDateString()}
          </p>

          <h3 className="text-xl font-serif font-bold text-charcoal mt-6 mb-3" data-id="element-73">
            1. Acceptance of Terms
          </h3>
          <p className="mb-4" data-id="element-74">
            By purchasing and using The Nervous System Sleep Reset guide, you
            agree to be bound by these Terms of Service. If you do not agree to
            these terms, please do not purchase or use our product.
          </p>

          <h3 className="text-xl font-serif font-bold text-charcoal mt-6 mb-3" data-id="element-75">
            2. Product Description
          </h3>
          <p className="mb-4" data-id="element-76">
            The Nervous System Sleep Reset is a digital guide providing
            information and techniques for helping babies sleep. This product is
            for educational and informational purposes only and is not a
            substitute for professional medical advice.
          </p>

          <h3 className="text-xl font-serif font-bold text-charcoal mt-6 mb-3" data-id="element-77">
            3. Medical Disclaimer
          </h3>
          <p className="mb-4" data-id="element-78">
            The information provided in this guide is not medical advice. Always
            consult with your pediatrician or healthcare provider before
            implementing any sleep training methods. Every baby is different,
            and what works for one may not work for another.
          </p>

          <h3 className="text-xl font-serif font-bold text-charcoal mt-6 mb-3" data-id="element-79">
            4. Refund Policy
          </h3>
          <p className="mb-4" data-id="element-80">
            We offer a 30-day money-back guarantee. If you are not satisfied
            with your purchase, contact us within 30 days of purchase for a full
            refund. Due to the digital nature of the product, refunds are
            processed at our discretion.
          </p>

          <h3 className="text-xl font-serif font-bold text-charcoal mt-6 mb-3" data-id="element-81">
            5. Intellectual Property
          </h3>
          <p className="mb-4" data-id="element-82">
            All content in The Nervous System Sleep Reset guide, including text,
            graphics, and methodology, is protected by copyright and
            intellectual property laws. You may not reproduce, distribute, or
            create derivative works without written permission.
          </p>

          <h3 className="text-xl font-serif font-bold text-charcoal mt-6 mb-3" data-id="element-83">
            6. License to Use
          </h3>
          <p className="mb-4" data-id="element-84">
            Upon purchase, you receive a personal, non-transferable license to
            use the guide for your own family. You may not share, resell, or
            distribute the content to others.
          </p>

          <h3 className="text-xl font-serif font-bold text-charcoal mt-6 mb-3" data-id="element-85">
            7. Limitation of Liability
          </h3>
          <p className="mb-4" data-id="element-86">
            We are not liable for any direct, indirect, incidental, or
            consequential damages arising from the use or inability to use our
            product. Results may vary, and we make no guarantees about specific
            outcomes.
          </p>

          <h3 className="text-xl font-serif font-bold text-charcoal mt-6 mb-3" data-id="element-87">
            8. User Responsibilities
          </h3>
          <p className="mb-4" data-id="element-88">You agree to:</p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-89">
            <li data-id="element-90">
              Use the guide responsibly and in accordance with medical advice
            </li>
            <li data-id="element-91">Not share or distribute the content without permission</li>
            <li data-id="element-92">Provide accurate information during purchase</li>
            <li data-id="element-93">Monitor your baby's safety and well-being at all times</li>
          </ul>

          <h3 className="text-xl font-serif font-bold text-charcoal mt-6 mb-3" data-id="element-94">
            9. Modifications to Service
          </h3>
          <p className="mb-4" data-id="element-95">
            We reserve the right to modify, update, or discontinue the product
            at any time. Existing customers will retain access to the version
            they purchased.
          </p>

          <h3 className="text-xl font-serif font-bold text-charcoal mt-6 mb-3" data-id="element-96">
            10. Governing Law
          </h3>
          <p className="mb-4" data-id="element-97">
            These terms are governed by applicable laws. Any disputes will be
            resolved through binding arbitration in accordance with local
            regulations.
          </p>

          <h3 className="text-xl font-serif font-bold text-charcoal mt-6 mb-3" data-id="element-98">
            11. Contact Information
          </h3>
          <p className="mb-4" data-id="element-99">
            For questions about these terms, please contact us through our
            support channels.
          </p>
        </div>
      </Modal>
    </>;
}